import type { TranslationMessages } from '../types';

export const common: TranslationMessages = {
  accessDenied: 'Access Denied',
  page: {
    loading: 'Loading',
  },
  navigation: {
    no_results: 'No results found',
  },
  action: {
    choose_language: 'Choose language',
    skip: 'Skip',
    actions: 'Actions',
    create: 'Create',
    clear: 'Clear',
    apply: 'Apply',
    help: 'Help',
    support: 'Support',
    open: 'Open',
    previous: 'Previous',
    next: 'Next',
    finish: 'Finish',
    close: 'Close',
    cancel: 'Cancel',
    load_more: 'Load more',
    confirm: 'Confirm',
    edit: 'Edit',
    show: 'Show',
    completed: 'Completed',
    available: 'Available',
    review: 'Review',
    refresh: 'Refresh',
    start: 'Start',
    filter: 'Filter',
    apply_filters: 'Apply Filters',
    clear_filters: 'Clear Filters',
    back_to_list: 'Back to List',
    search_placeholder: 'Search...',
    loading: 'Loading...',
    error_loading: 'Error loading data',
    failed_to_load: 'Failed to load data. Please try again.',
    failed_to_save: 'Failed to save. Please try again.',
    failed_to_delete: 'Failed to delete. Please try again.',
    failed_to_create: 'Failed to create. Please try again.',
    failed_to_update: 'Failed to update. Please try again.',
    toggle_theme: 'Toggle theme',
    clear_all_filters: 'Clear all filters',
    table_view: 'Table View',
    card_view: 'Card View',
    select_category: 'Select category',
    select_status: 'Select status',
    minimum_amount: 'Minimum total amount',
    back: 'Back',
    save: 'Save',
    saving: 'Saving...',
    search: 'Search',
    delete: 'Delete',
    add_filter: 'Add filter',
    yes: 'Yes',
  },
  // Direct access for pos.common.save (alias to action.save)
  save: 'Save',
  message: {
    forbidden: 'You do not have permission to access this page',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    updated: 'Updated',
    error: 'Error',
    empty: 'No users found',
    delete_title: 'Delete User',
    delete_content: 'Are you sure you want to delete this item?',
    success: 'Success',
  },
  notification: {
    error: 'Error',
    item_doesnt_exist: 'Item does not exist',
  },
  field: {
    notes: 'Notes',
  },
  loadingCosts: 'Loading costs...',
  loadingCostCategories: 'Loading cost categories...',
  failedToLoadCosts: 'Failed to load costs',
  failedToLoadCostCategories: 'Failed to load cost categories',
  loadingCategory: 'Loading category...',
  categoryNotFound: 'Category not found',
  backToCategories: 'Back to Categories',
  loading: 'Loading',
  failedToDeleteCost: 'Failed to delete cost',
  confirmDeleteCost: 'Are you sure you want to delete this cost?',
  loadingCostEntry: 'Loading cost entry...',
};
